import React, {useEffect, useState} from 'react';
import DisposeTableItem from "../../../base/dispose-tab-item";


interface IComponentProps {
  data?: any;
}
const DepositItem: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const [ dataList, setDataList ] = useState<any[]>([])

  useEffect(() => {
    const { deposit_broken, deposit_illegal  } = data
    const list = []
    if (Number(deposit_broken) > 0) {
      list.push({
        text: `车损押金: ${deposit_broken / 100}元`,
      })
    }
    if (Number(deposit_illegal) > 0 ) {
      list.push({
        text: `违章押金: ${deposit_illegal / 100}元`,
      })
    }
    setDataList(list)
  }, [data]);

  return (
    <>
      <DisposeTableItem dataList={dataList}></DisposeTableItem>
    </>
  );
};

export default DepositItem;
